import {
  Button,
  Cascader,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Switch,
  Table,
  DatePicker,
  message,
  Modal,
  Card,
  Radio,
} from 'antd';
import { ColumnsType } from 'antd/es/table';
import {
  getProductUpdateInfoNew,
  getProductListNew,
  getProductPriceComparison,
  PmsProductEs,
  publishProduct,
  syncProductToEs,
  unPublishProduct,
  updateStockStatus,
  updateProductRemark,
  deleteProduct,
  soldProductBindOrder,
  copyProductImages,
  batchConvertToMultiStock,
} from 'apis/pms';
import usePagination from 'commons/hooks/usePagination';
import LOCALS from 'commons/locals';
import {
  findLabelByValue,
  PMS_PRODUCT_STOCK_STATUS_OPTION_LIST,
  PMS_PRODUCT_STOCK_STATUS,
  PRODUCT_STOCK_TYPE,
  PRODUCT_STOCK_TYPE_OPTION_LIST,
} from 'commons/options';
import dayjs from 'dayjs';
import i18n from 'i18n';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { UnwrapPromise } from 'types/base';
import { PmsProduct, PriceTagInfo } from 'types/pms';
import formatTime from 'utils/formatTime';
import ImageSliceShow from 'components/image-slice-show';
import classNames from 'classnames';
import findCascaderOptionById from 'utils/findCascaderOptionById';
import useResource from 'commons/hooks/useResource';
import getCascaderFilter from 'utils/getCascaderFilter';
import ProductStockStatusHistory from './product-stock-status-history';
import LinkButton from 'components/link-button';
import { useToggle } from 'react-use';
import { selectUserInfo } from 'store/slices/userInfoSlice';
import getUpdateProductStockStatusOptions from 'utils/get-update-product-stock-status-options';
import CopyButton from 'components/copy-button';
import { CONSUMPTION_TAX_RATE } from '../../constant';
import * as XLSX from 'xlsx';
import { priceToWithoutTax } from 'utils/price-change';
import getProductDisplayInfo from 'utils/get-product-display-info';
import ChangeStockButton from './change-stock-button';
import {
  parseAsArrayOf,
  parseAsBoolean,
  parseAsInteger,
  parseAsString,
  useQueryState,
} from 'nuqs';
import { Eye, Plus } from 'lucide-react';
import {
  getLentOutRemarkDisplay,
  updateProductsWithMaintenanceRemark,
} from './stock-status-remark-utils';
import { CURRENCY_MAP } from 'constant/currency';
import { STOCK_PLACE_OPTION_LIST } from 'constant/stock-place';
import { PUBLISH_STATUS_OPTION_LIST } from 'constant/pms-product';
import {
  PROMOTION_TYPE_MAP,
  PRODUCT_SOURCE_TYPE_OPTION_LIST,
} from 'constant/pms-product';

const { RangePicker } = DatePicker;

const BATCH_OPTION_TYPE = {
  BATCH_PRINT: 'BATCH_PRINT', // 批量打印价签
  BATCH_PRINT_LABEL: 'BATCH_PRINT_LABEL', // 批量打印
  BATCH_STOCK: 'BATCH_STOCK', // 批量入库
  BATCH_FOR_SALE: 'BATCH_FOR_SALE', // 批量售卖
  BATCH_PUBLISH: 'BATCH_PUBLISH', // 批量上架网站
  BATCH_UN_PUBLISH: 'BATCH_UN_PUBLISH', // 批量下架网站
  BATCH_SOLD_OUT: 'BATCH_SOLD_OUT', // 批量卖出
  BATCH_LENT_OUT: 'BATCH_LENT_OUT', // 批量借出
  BATCH_BIND_ORDER: 'BATCH_BIND_ORDER', // 批量绑定订单
  BATCH_CONVERT_TO_MULTI_STOCK: 'BATCH_CONVERT_TO_MULTI_STOCK', // 批量转为多库存
  BATCH_SYNC_ES: 'BATCH_SYNC_ES', // 批量同步 ES
};

const useQueryParams = () => {
  const [pageNum, setPageNum] = useQueryState(
    'pageNum',
    parseAsInteger.withDefault(1),
  );
  const [pageSize, setPageSize] = useQueryState(
    'pageSize',
    parseAsInteger.withDefault(10),
  );
  const [productCategoryIds, setProductCategoryIds] = useQueryState(
    'productCategoryIds',
    parseAsArrayOf(parseAsInteger),
  );
  const [keyword, setKeyword] = useQueryState(
    'keyword',
    parseAsString.withDefault(''),
  );
  const [publishStatus, setPublishStatus] = useQueryState(
    'publishStatus',
    parseAsInteger,
  );
  const [stockPlaces, setStockPlaces] = useQueryState(
    'stockPlaces',
    parseAsArrayOf(parseAsString),
  );
  const [rankList, setRankList] = useQueryState(
    'rankList',
    parseAsArrayOf(parseAsString),
  );
  const [brandNameList, setBrandNameList] = useQueryState(
    'brandNameList',
    parseAsArrayOf(parseAsString),
  );
  const [isHavePic, setIsHavePic] = useQueryState('isHavePic', parseAsBoolean);
  const [sourceTypeList, setSourceTypeList] = useQueryState(
    'sourceTypeList',
    parseAsArrayOf(parseAsInteger),
  );
  const [isFilterPromotion, setIsFilterPromotion] = useQueryState(
    'isFilterPromotion',
    parseAsBoolean.withDefault(false),
  );
  const [createTime, setCreateTime] = useQueryState(
    'createTime',
    parseAsArrayOf(parseAsString).withDefault([]),
  );
  const [soldTime, setSoldTime] = useQueryState(
    'soldTime',
    parseAsArrayOf(parseAsString).withDefault([]),
  );
  const [stockStatuses, setStockStatuses] = useQueryState(
    'stockStatuses',
    parseAsArrayOf(parseAsString).withDefault([]),
  );
  const [skuType, setSkuType] = useQueryState('skuType', parseAsInteger);
  const [haveOrderId, setHaveOrderId] = useQueryState(
    'haveOrderId',
    parseAsBoolean,
  );
  const [entryTime, setEntryTime] = useQueryState(
    'entryTime',
    parseAsArrayOf(parseAsString).withDefault([]),
  );

  return {
    pageNum,
    pageSize,
    productCategoryIds,
    keyword,
    publishStatus,
    stockPlaces,
    rankList,
    brandNameList,
    isHavePic,
    sourceTypeList,
    isFilterPromotion,
    createTime,
    soldTime,
    stockStatuses,
    skuType,
    haveOrderId,
    entryTime,
    setPublishStatus,
    setProductCategoryIds,
    setKeyword,
    setPageNum,
    setPageSize,
    setStockPlaces,
    setRankList,
    setBrandNameList,
    setIsHavePic,
    setSourceTypeList,
    setIsFilterPromotion,
    setCreateTime,
    setSoldTime,
    setStockStatuses,
    setHaveOrderId,
    setEntryTime,
    setSkuType,
  };
};

const ProductList = () => {
  const {
    pageNum,
    pageSize,
    keyword,
    publishStatus,
    stockPlaces,
    rankList,
    brandNameList,
    isHavePic,
    sourceTypeList,
    isFilterPromotion,
    createTime,
    soldTime,
    productCategoryIds,
    stockStatuses,
    haveOrderId,
    entryTime,
    skuType,
    setKeyword,
    setPublishStatus,
    setPageNum,
    setPageSize,
    setStockPlaces,
    setRankList,
    setBrandNameList,
    setIsHavePic,
    setSourceTypeList,
    setIsFilterPromotion,
    setCreateTime,
    setSoldTime,
    setProductCategoryIds,
    setStockStatuses,
    setSkuType,
    setHaveOrderId,
    setEntryTime,
  } = useQueryParams();

  // 为 keyword 添加本地状态，避免实时同步 URL
  const [localKeyword, setLocalKeyword] = useState(keyword);

  // 同步 URL 中的 keyword 变化到本地状态
  useEffect(() => {
    setLocalKeyword(keyword);
  }, [keyword]);

  const {
    productCategoryCascaderOptions,
    colorSelectOptions,
    materialCascaderOptionsMap,
    hardwareSelectOptions,
    rankSelectOptions,
    stampSelectOptions,
    brandNameSelectOptions,
    accessorySelectOptions,
  } = useAppSelector(selectGlobalInfo);
  const { isAdmin, menus } = useAppSelector(selectUserInfo);
  const { loading, setLoading, total, setTotal, dataSource, setDataSource } =
    usePagination<
      PmsProductEs & {
        colorText: string;
        materialText: string;
        hardwareText: string;
        stampText: string;
      }
    >();
  const [selectedRows, setSelectedRows] = useState<PmsProductEs[]>([]);
  const isProductForSaleToSold = useResource('product-for-sale-to-sold');
  // 添加删除权限控制
  const canDeleteProduct = useResource('product-delete');
  const canViewProduct = menus.some((menu) => menu.name === 'product-view');
  const canEditProduct = menus.some((menu) => menu.name === 'product-edit');
  const canAddProduct = menus.some((menu) => menu.name === 'product-add');
  const [updateStockStatusData, setUpdateStockStatus] = useState<{
    productIdList: number[];
    newStockStatus: PMS_PRODUCT_STOCK_STATUS;
    note?: string;
    selectedLentOutPresetKey?: string;
  }>();

  const normalizeNoteToEn = useCallback((note: string) => {
    const presetKeys = [
      LOCALS.lent_out_preset_maintenance,
      LOCALS.lent_out_preset_photography,
      LOCALS.lent_out_preset_display,
    ];
    return presetKeys.reduce((result, key) => {
      const en = i18n.t(key, { lng: 'en' });
      return ['ja', 'zh_CN'].reduce((acc, lng) => {
        const localized = i18n.t(key, { lng });
        return localized && localized !== en
          ? acc.replaceAll(localized, en)
          : acc;
      }, result);
    }, note);
  }, []);

  const [productStockStatusStatistics, setProductStockStatusStatistics] =
    useState<
      UnwrapPromise<ReturnType<typeof getProductListNew>>['statisticsResult']
    >([]);

  const [viewStockStatusProductId, setViewStockStatusProductId] = useState(0);

  const searchProductList = useCallback(
    async (customPageNum?: number, customPageSize?: number) => {
      if (
        !productCategoryCascaderOptions.length ||
        !stampSelectOptions.length ||
        !colorSelectOptions.length ||
        !hardwareSelectOptions.length
      )
        return {
          total: 0,
          list: [],
          statisticsResult: [],
        };

      const stockPlacesFiltered = stockPlaces?.filter(Boolean) ?? [];
      const stockPlacesPayload = stockPlacesFiltered.length
        ? stockPlacesFiltered
        : undefined;

      const { total, list, statisticsResult } = await getProductListNew({
        pageNum: customPageNum || pageNum,
        pageSize: customPageSize || pageSize,
        keyword,
        productCategoryId:
          productCategoryIds === null
            ? undefined
            : productCategoryIds[productCategoryIds.length - 1],
        publishStatus: publishStatus === null ? undefined : publishStatus,
        stockPlaces: stockPlacesPayload,
        rankList: rankList === null ? undefined : rankList,
        brandNameList: brandNameList === null ? undefined : brandNameList,
        isHavePic: isHavePic === null ? undefined : isHavePic,
        sourceTypeList: sourceTypeList === null ? undefined : sourceTypeList,
        skuType: skuType === null ? undefined : skuType,
        isFilterPromotion:
          isFilterPromotion === null ? undefined : isFilterPromotion,
        start: createTime[0] || undefined,
        end: createTime[1] || undefined,
        soldStart: soldTime[0] || undefined,
        soldEnd: soldTime[1] || undefined,
        stockStatuses: stockStatuses === null ? undefined : stockStatuses,
        haveOrderId: haveOrderId === null ? undefined : haveOrderId,
        entryStart: entryTime[0] || undefined,
        entryEnd: entryTime[1] || undefined,
      });

      setProductStockStatusStatistics(statisticsResult);

      return {
        total,
        list: list.map((i) => {
          // color
          const colorTextList: string[] = [];
          i.colors &&
            i.colors.split(',')?.forEach((d: string) => {
              const t = colorSelectOptions.find((dd) => dd.value === d);
              if (t) colorTextList.push(t.label);
            });

          // material
          const materialTextList: string[] = [];
          const target = findCascaderOptionById(
            i.productCategoryId,
            productCategoryCascaderOptions,
          );
          const productCategoryIds =
            target?.treeIds?.split(',')?.map(Number) || [];
          const mateList =
            materialCascaderOptionsMap[productCategoryIds[0]] || [];
          i.materialStr &&
            i.materialStr
              .split(',')
              .filter(Boolean)
              .forEach((d: string) => {
                const t = findCascaderOptionById(d, mateList);
                if (t) materialTextList.push(t.label);
              });

          // hardware
          const hardwareTextList: string[] = [];
          i.hardware &&
            i.hardware.forEach((value) => {
              const t = hardwareSelectOptions.find((dd) => dd.value === value);
              if (t && t.value !== 'none') hardwareTextList.push(t.label || '');
            });

          // stamp
          const stampText =
            stampSelectOptions.find(
              (d) => d.value === i.stamp && d.value !== 'none',
            )?.label || '';

          return {
            ...i,
            colorText: colorTextList.toString(),
            materialText: materialTextList.toString(),
            hardwareText: hardwareTextList.toString(),
            stampText,
          };
        }),
      };
    },
    [
      productCategoryCascaderOptions,
      stampSelectOptions,
      colorSelectOptions,
      hardwareSelectOptions,
      pageNum,
      pageSize,
      keyword,
      productCategoryIds,
      publishStatus,
      stockPlaces,
      rankList,
      brandNameList,
      isHavePic,
      sourceTypeList,
      skuType,
      isFilterPromotion,
      createTime,
      soldTime,
      stockStatuses,
      haveOrderId,
      entryTime,
      materialCascaderOptionsMap,
    ],
  );

  const getDataSource = useCallback(async () => {
    try {
      setLoading(true);
      const { total, list } = await searchProductList();
      setDataSource(list);
      setTotal(total);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  }, [searchProductList, setDataSource, setLoading, setTotal]);

  useEffect(() => {
    getDataSource();
  }, [getDataSource]);

  const onView = useCallback((id: PmsProduct['id']) => {
    window.location.href = `/pms/product-view/${id}`;
  }, []);

  const onEdit = useCallback((id: PmsProduct['id']) => {
    // 为改变url 触发 beforeunload
    window.location.href = `/pms/product-edit/${id}`;
  }, []);

  // 添加删除商品的函数
  const handleDelete = useCallback(
    async (id: number) => {
      Modal.confirm({
        title: i18n.t('XQTIAmaivc'),
        content: i18n.t('iIJPjfkyBr'),
        okText: i18n.t('confirm'),
        okType: 'danger',
        cancelText: i18n.t('cancel'),
        onOk: async () => {
          try {
            await deleteProduct(id);
            message.success(i18n.t('KJNCWPDiRG'));
            // 刷新当前页面数据
            getDataSource();
          } catch (error) {
            message.error(i18n.t('pTYrCpwbRm'));
          }
        },
      });
    },
    [getDataSource],
  );

  const handleCopyImages = useCallback((sourceProductId: number) => {
    let targetProductId: number | null = null;
    Modal.confirm({
      title: '图片复制',
      content: (
        <div className="pt-2">
          <div className="mb-2 text-gray-500">
            将来源商品 {sourceProductId} 的相册和内部照片复制到目标商品
          </div>
          <InputNumber
            className="w-full"
            placeholder="请输入目标商品 ID"
            min={1}
            precision={0}
            onChange={(value) => {
              targetProductId = typeof value === 'number' ? value : null;
            }}
          />
        </div>
      ),
      okText: i18n.t('confirm'),
      cancelText: i18n.t('cancel'),
      onOk: async () => {
        if (!targetProductId) {
          message.error('请输入目标商品 ID');
          return Promise.reject();
        }
        if (targetProductId === sourceProductId) {
          message.error('目标商品不能与来源商品相同');
          return Promise.reject();
        }
        const results = await copyProductImages([
          { sourceProductId, targetProductId },
        ]);
        const result = results[0];
        if (result?.success) {
          message.success(result.message || '照片复制成功');
        } else {
          message.error(result?.message || '复制失败');
          return Promise.reject();
        }
      },
    });
  }, []);

  const handlePublishStatusChange = useCallback(
    async (checked: boolean, id: PmsProduct['id']) => {
      if (checked) {
        await publishProduct([id]);
      } else {
        await unPublishProduct([id]);
      }

      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    [],
  );

  /** 跳转打印 */
  const handleForwardPrint = useCallback(
    (data: PmsProductEs[]) => {
      if (data.length > 24) {
        message.warning(i18n.t('supports_up_to_18_items'));
        return;
      }
      const newData: PriceTagInfo[] = [];
      data.forEach((d) => {
        const {
          id,
          name,
          productCategoryId,
          productSn,
          costPrice,
          price,
          sourceType,
          colors,
          hardware,
          rank,
          stamp,
          currency,
          createdTime,
          entryTime,
          brandName,
          referencePrice,
          name_ja,
          name_en,
          fullStamp,
          materialStr,
        } = d;

        const displayInfo = getProductDisplayInfo({
          lang: currency === CURRENCY_MAP.JPY ? 'ja' : 'en',
          productInfo: {
            name: name_en || name,
            i18nList: [
              {
                lang: 'ja',
                name: name_ja,
              },
            ],
            productCategoryId: productCategoryId,
            stamp: stamp || '',
            rank,
            color: colors || '',
            material: materialStr ? materialStr : '',
            hardware: hardware ? hardware.toString() : '',
            accessory: '',
            rankDescription: '',
          },
          options: {
            productCategoryCascaderOptions,
            materialCascaderOptionsMap,
            colorSelectOptions,
            rankSelectOptions,
            stampSelectOptions,
            hardwareSelectOptions,
            accessorySelectOptions,
          },
        });

        newData.push({
          id,
          name: displayInfo.name || '',
          productSn,
          price,
          costPrice: Number(costPrice) || 0,
          sourceType,
          color: displayInfo.color,
          material: displayInfo.material,
          hardware: displayInfo.hardware,
          rank: displayInfo.rank,
          stamp: displayInfo.stamp,
          createTime: createdTime,
          entryTime,
          brandName,
          referencePrice,
          currency,
          fullStamp,
        });
      });

      // 填充数据
      const arrayFill = Array.from({ length: 24 }, (_, i) => {
        if (newData[i]) {
          return { ...newData[i] };
        } else {
          return { id: i };
        }
      });

      localStorage.setItem('price-tag', JSON.stringify(arrayFill));
      window.open('/prints/price-tag');
    },
    [
      productCategoryCascaderOptions,
      materialCascaderOptionsMap,
      colorSelectOptions,
      rankSelectOptions,
      stampSelectOptions,
      hardwareSelectOptions,
      accessorySelectOptions,
    ],
  );

  const handleForwardPrintLabel = useCallback(
    (data: PmsProductEs[]) => {
      if (data.length > 9) {
        message.warning(i18n.t('supports_up_to_n_items', { count: 9 }));
        return;
      }
      const newData: PriceTagInfo[] = [];
      data.forEach((d) => {
        const {
          id,
          productCategoryId,
          productSn,
          costPrice,
          price,
          colors: attrColor,
          hardware: attrHardware,
          materialStr,
          rank,
          stamp: attrStamp,
          currency,
          brandName,
          referencePrice,
        } = d;
        // color
        const color: string[] = [];
        attrColor &&
          attrColor.split(',')?.forEach((d: string) => {
            const t = colorSelectOptions.find((dd) => dd.value === d);
            if (t) color.push(t.labelEn || '');
          });

        const target = findCascaderOptionById(
          productCategoryId,
          productCategoryCascaderOptions,
        );
        const productCategoryIds =
          target?.treeIds?.split(',')?.map(Number) || [];
        const mateList =
          materialCascaderOptionsMap[productCategoryIds[0]] || [];

        // material
        const material: string[] = [];
        materialStr &&
          materialStr
            .split(',')
            .filter(Boolean)
            .forEach((d: string) => {
              const t = findCascaderOptionById(d, mateList);
              if (t) material.push(t.labelEn || '');
            });

        const stampStr =
          stampSelectOptions.find((d) => d.value === attrStamp)?.labelEn || '';

        const hardware: string[] = [];
        attrHardware &&
          attrHardware.forEach((value) => {
            const t = hardwareSelectOptions.find((dd) => dd.value === value);
            if (t) hardware.push(t.labelEn || '');
          });
        newData.push({
          id,
          name: target?.nameEn || '',
          productSn,
          price,
          costPrice: Number(costPrice) || 0,
          color: color.toString(),
          material: material.toString(),
          hardware: hardware.toString(),
          rank,
          stamp: stampStr,
          brandName,
          referencePrice,
          currency,
        });
      });

      localStorage.setItem('price-label', JSON.stringify(newData));
      window.open('/prints/price-label');
    },
    [
      productCategoryCascaderOptions,
      materialCascaderOptionsMap,
      stampSelectOptions,
      colorSelectOptions,
      hardwareSelectOptions,
    ],
  );

  const columns: ColumnsType<PmsProductEs> = useMemo(() => {
    const columnList1: ColumnsType<PmsProductEs> = [
      {
        title: <Trans i18nKey={LOCALS.product_sn}></Trans>,
        key: 'productSn',
        render: ({ id, description }: PmsProductEs) => {
          return (
            <>
              <span
                className="text-[#69b1ff] cursor-pointer"
                onClick={() => {
                  const host = window.location.host;
                  if (host === 'admin-shop.ginzaxiaoma.com') {
                    window.open(`//ginzaxiaoma.com/product/${id}`);
                  } else {
                    window.open(`//test-shop.ginzaxiaoma.com/product/${id}`);
                  }
                }}
              >
                {id}
              </span>
              {description && (
                <CopyButton copyText={description}>{description}</CopyButton>
              )}
            </>
          );
        },
      },
      {
        dataIndex: 'albumPics',
        key: 'albumPics',
        title: <Trans i18nKey={LOCALS.product_pictures} />,
        align: 'center',
        render: (albumPics: string) => {
          if (!albumPics) return <span>-</span>;
          let picList: string[] = albumPics.split(',');
          return (
            <ImageSliceShow
              imgList={picList}
              endSliceNumber={1}
              style={{ marginRight: 0 }}
            />
          );
        },
      },
      {
        dataIndex: 'name',
        key: 'name',
        title: <Trans i18nKey={LOCALS.product_name} />,
        render: (name: string, product: PmsProductEs) => {
          const color: string[] = [];
          product.colors &&
            product.colors.split(',')?.forEach((d: string) => {
              const t = colorSelectOptions.find((dd) => dd.value === d);
              if (t) color.push(t.label);
            });

          // material
          const material: string[] = [];
          const target = findCascaderOptionById(
            product.productCategoryId,
            productCategoryCascaderOptions,
          );
          const productCategoryIds =
            target?.treeIds?.split(',')?.map(Number) || [];
          const mateList =
            materialCascaderOptionsMap[productCategoryIds[0]] || [];

          product.materialStr &&
            product.materialStr
              .split(',')
              .filter(Boolean)
              .forEach((d: string) => {
                const t = findCascaderOptionById(d, mateList);
                if (t) material.push(t.label);
              });

          const hardware: string[] = [];
          product.hardware &&
            product.hardware.forEach((value) => {
              const t = hardwareSelectOptions.find((dd) => dd.value === value);
              if (t && t.value !== 'none') hardware.push(t.label || '');
            });

          // stamp
          const stampStr =
            stampSelectOptions.find(
              (d) => d.value === product.stamp && d.value !== 'none',
            )?.label || '';

          const { rank } = product;

          // TODO: 优化
          return (
            <div className="max-w-72">
              <div>{name}</div>
              {
                <div>
                  <Trans i18nKey={LOCALS.rank} />：
                  {rankSelectOptions.find((i) => i.value === rank)?.label}
                </div>
              }
              {!!color.length && (
                <div>
                  <Trans i18nKey={LOCALS.color} />：{color.toString()}
                </div>
              )}
              {!!material.length && (
                <div>
                  <Trans i18nKey={LOCALS.material} />：{material.toString()}
                </div>
              )}
              {!!hardware.length && (
                <div>
                  <Trans i18nKey={LOCALS.hardware} />：{hardware.toString()}
                </div>
              )}
              {!!stampStr && (
                <div>
                  <Trans i18nKey={LOCALS.stamp} />：{stampStr}
                </div>
              )}
            </div>
          );
        },
      },
      {
        key: 'stockStatus',
        dataIndex: 'stockStatus',
        title: i18n.t(LOCALS.uMihwkqqts),
        render: (
          stockStatus: PmsProductEs['stockStatus'],
          { id, remark }: PmsProductEs,
        ) => {
          const options = getUpdateProductStockStatusOptions({
            initStockStatus: stockStatus,
            isProductForSaleToSold,
          });
          const lentOutRemarkDisplay = getLentOutRemarkDisplay(
            stockStatus,
            remark,
          );

          return (
            <div className="space-y-2">
              <div className="flex items-center justify-center">
                <Select
                  className="w-32"
                  size="small"
                  value={stockStatus}
                  options={options}
                  onChange={(e) => {
                    setUpdateStockStatus({
                      productIdList: [id],
                      newStockStatus: e,
                    });
                  }}
                />
                <Button
                  type="link"
                  onClick={() => {
                    setViewStockStatusProductId(id);
                  }}
                >
                  <Eye />
                </Button>
              </div>
              {lentOutRemarkDisplay && (
                <div className="max-w-44 whitespace-pre-line break-words text-xs text-red-500">
                  {lentOutRemarkDisplay}
                </div>
              )}
            </div>
          );
        },
      },
    ];

    const columnList2: ColumnsType<PmsProductEs> = [
      {
        key: 'sourceType',
        dataIndex: 'sourceType',
        title: <Trans i18nKey={LOCALS.product_source} />,
        render: (sourceType: PmsProductEs['sourceType']) => {
          return findLabelByValue(sourceType, PRODUCT_SOURCE_TYPE_OPTION_LIST);
        },
      },
      {
        key: 'price',
        title: <Trans i18nKey={LOCALS.price} />,
        render: (product: PmsProductEs) => {
          const { promotionType, priceJpy, currency } = product;

          const costPriceEle = product?.costPrice ? (
            <div>
              {i18n.t('purchase_price')}: {currency}{' '}
              {product.costPrice.toLocaleString()}
            </div>
          ) : null;

          // 只判断币种是否为日元，然后显示免税价格
          const taxFreePriceElement =
            currency === CURRENCY_MAP.JPY ? (
              <div>
                {i18n.t('czbRYWhFdZ')}：{currency}{' '}
                {priceToWithoutTax(product.price).toLocaleString()}
              </div>
            ) : null;

          return (
            <>
              <div>
                {i18n.t('selling_price')}:{' '}
                <span
                  style={
                    promotionType === PROMOTION_TYPE_MAP.SPECIAL
                      ? {
                          color: 'var(--color-danger)',
                        }
                      : undefined
                  }
                >
                  {currency} {product.price?.toLocaleString() || '-'}
                </span>
              </div>
              {taxFreePriceElement}
              {currency !== CURRENCY_MAP.JPY && (
                <div>
                  {i18n.t('convert_to_jpy')}: JPY{' '}
                  {priceJpy.toLocaleString() || '-'}
                </div>
              )}

              {costPriceEle}
            </>
          );
        },
      },
      {
        dataIndex: 'stockPlace',
        key: 'stockPlace',
        title: <Trans i18nKey={LOCALS.stock_place} />,
        render: (stockPlace: PmsProductEs['stockPlace']) => {
          return findLabelByValue(stockPlace, STOCK_PLACE_OPTION_LIST);
        },
      },
      {
        key: 'recycleOrder',
        title: i18n.t(LOCALS.ZQDTJFXciM),
        render: ({ recycleOrderId, recycleOrderCode }: PmsProductEs) => {
          if (!recycleOrderId) {
            return '-';
          }

          return (
            <LinkButton
              href={`/rrs/recycling-consignment-detail/${recycleOrderId}`}
            >
              {recycleOrderCode || recycleOrderId}
            </LinkButton>
          );
        },
      },
      {
        key: 'memberSource',
        title: <Trans i18nKey={LOCALS.inventory_source} />,
        render: ({ memberId, email }: PmsProductEs) => {
          if (!memberId) return '-';
          return (
            <LinkButton href={`/ums/member-view/${memberId}`}>
              {email}
            </LinkButton>
          );
        },
      },
      {
        dataIndex: 'createdTime',
        key: 'createdTime',
        title: <Trans i18nKey={LOCALS.created_time} />,
        render: (createdTime: PmsProduct['createdTime']) => {
          return <div>{formatTime(createdTime)}</div>;
        },
      },
      {
        dataIndex: 'entryTime',
        key: 'entryTime',
        title: i18n.t(LOCALS.juusvCbRWo),
        render: (entryTime: PmsProduct['entryTime']) => {
          return <div>{formatTime(entryTime)}</div>;
        },
      },
    ];

    const publishStatusColumn: ColumnsType<PmsProductEs>[number] = {
      key: 'publishStatus',
      title: <Trans i18nKey={LOCALS.publish_status} />,
      render: (_: any, product: PmsProductEs) => {
        const { publishStatus, id } = product;
        return (
          <div className="text-center">
            <Switch
              checked={publishStatus === 1}
              onChange={(checked) => {
                handlePublishStatusChange(checked, id);
              }}
            />
          </div>
        );
      },
    };

    const stockColumn: ColumnsType<PmsProductEs>[number] = {
      title: i18n.t(LOCALS.stock),
      key: 'stock',
      render: ({ stock }: PmsProductEs, product: PmsProductEs) => {
        return (
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center justify-center">
              {stock}
              <ChangeStockButton product={product} />
            </div>
            <div className="text-xs text-gray-400">
              {product.skuType === PRODUCT_STOCK_TYPE.MULTI
                ? i18n.t(LOCALS.rtjLykJLYo)
                : i18n.t(LOCALS.KDYOlENnJC)}
            </div>
          </div>
        );
      },
    };

    const soldInfoColumn: ColumnsType<PmsProductEs>[number] = {
      title: i18n.t(LOCALS.bxYXkMWIQe),
      key: 'soldInfo',
      render({ soldTime, orderId }: PmsProductEs) {
        if (!orderId) {
          return '-';
        }

        return (
          <div>
            <LinkButton href={`/oms/order-view/${orderId}`}>
              {orderId}
            </LinkButton>
            <br />
            {formatTime(soldTime)}
          </div>
        );
      },
    };

    const optionColumn: ColumnsType<PmsProductEs>[number] = {
      key: 'options',
      title: <Trans i18nKey={LOCALS.option} />,
      fixed: 'right',
      render: ({ id }: PmsProductEs, record) => {
        // 判断商品是否可删除 - 增加权限判断
        const canDelete =
          canDeleteProduct && // 增加权限判断
          record.stockStatus !== PMS_PRODUCT_STOCK_STATUS.SOLD &&
          record.stockStatus !== PMS_PRODUCT_STOCK_STATUS.RESERVED;
        return (
          <div className="grid">
            {canViewProduct && !canEditProduct && (
              <Button
                type="link"
                onClick={() => {
                  onView(id);
                }}
              >
                <Trans i18nKey={LOCALS.view} />
              </Button>
            )}

            {canEditProduct && (
              <Button
                type="link"
                onClick={() => {
                  onEdit(id);
                }}
              >
                <Trans i18nKey={LOCALS.edit} />
              </Button>
            )}

            <Button type="link" onClick={() => handleForwardPrint([record])}>
              <Trans i18nKey={LOCALS.cDYPiRpTxM} />
            </Button>

            <Button
              type="link"
              onClick={() => handleForwardPrintLabel([record])}
            >
              {i18n.t(LOCALS.SAnwKhjJJd)}
            </Button>

            {isAdmin &&
              record.stockStatus === PMS_PRODUCT_STOCK_STATUS.SOLD && (
                <Button
                  type="link"
                  onClick={async () => {
                    const res = await soldProductBindOrder([id]);
                    const result = res.results[0];
                    if (result?.success) {
                      message.success('绑定订单成功');
                      getDataSource();
                    } else {
                      message.error(result?.message || '绑定订单失败');
                    }
                  }}
                >
                  绑定订单
                </Button>
              )}

            {isAdmin && (
              <Button
                type="link"
                onClick={async () => {
                  await syncProductToEs([id]);
                  setTimeout(() => {
                    window.location.reload();
                  }, 500);
                }}
              >
                同步ES
              </Button>
            )}

            {isAdmin && (
              <Button type="link" onClick={() => handleCopyImages(id)}>
                图片复制
              </Button>
            )}

            {canDelete && (
              <Button
                type="link"
                danger
                onClick={(e) => {
                  handleDelete(id);
                }}
              >
                <Trans i18nKey={LOCALS.delete} />
              </Button>
            )}
          </div>
        );
      },
    };

    return [
      ...columnList1,
      publishStatusColumn,
      stockColumn,
      ...columnList2,
      soldInfoColumn,
      optionColumn,
    ];
  }, [
    canDeleteProduct,
    canEditProduct,
    canViewProduct,
    colorSelectOptions,
    getDataSource,
    handleCopyImages,
    handleDelete,
    handleForwardPrint,
    handleForwardPrintLabel,
    handlePublishStatusChange,
    hardwareSelectOptions,
    isAdmin,
    isProductForSaleToSold,
    materialCascaderOptionsMap,
    onEdit,
    onView,
    productCategoryCascaderOptions,
    rankSelectOptions,
    stampSelectOptions,
  ]);

  const batchOptionList = useMemo(() => {
    const options: {
      value: string;
      label: string;
    }[] = [];

    options.push({
      value: BATCH_OPTION_TYPE.BATCH_PRINT,
      label: i18n.t(LOCALS.UkQnhHkZxc),
    });

    options.push({
      value: BATCH_OPTION_TYPE.BATCH_PRINT_LABEL,
      label: i18n.t(LOCALS.dhDBFGAEfU),
    });

    // 商品都是待入库状态
    if (
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.PENDING_ENTRY,
      ) ||
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.LENT_OUT,
      )
    ) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_STOCK,
        label: i18n.t(LOCALS.kUJWWIcHRk),
      });
    }

    // 商品都是已入库状态
    if (
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.STOCKED,
      ) ||
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.LENT_OUT,
      )
    ) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_FOR_SALE,
        label: i18n.t(LOCALS.PWWODvsPvK),
      });
    }

    // 商品都是已入库状态 & 下架中状态
    if (
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.FOR_SALE,
      ) &&
      selectedRows.every((i) => i.publishStatus === 0)
    ) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_PUBLISH,
        label: i18n.t(LOCALS.rhCgCypWuW),
      });
    }

    // 商品都是已入库状态 & 上架中状态
    if (
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.FOR_SALE,
      ) &&
      selectedRows.every((i) => i.publishStatus === 1)
    ) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_UN_PUBLISH,
        label: i18n.t(LOCALS.kWaTarLxzT),
      });
    }

    if (
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.STOCKED,
      ) ||
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.FOR_SALE,
      )
    ) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_LENT_OUT,
        label: i18n.t(LOCALS.UNcgaTHsci),
      });
    }

    if (
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.FOR_SALE,
      ) &&
      isProductForSaleToSold
    ) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_SOLD_OUT,
        label: i18n.t(LOCALS.KpQUBrSjzY),
      });
    }

    if (
      isAdmin &&
      selectedRows.every(
        (i) => i.stockStatus === PMS_PRODUCT_STOCK_STATUS.SOLD && !i.orderId,
      )
    ) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_BIND_ORDER,
        label: '批量绑定订单',
      });
    }

    if (
      isAdmin &&
      selectedRows.length > 0 &&
      selectedRows.every((i) => i.skuType !== PRODUCT_STOCK_TYPE.MULTI)
    ) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_CONVERT_TO_MULTI_STOCK,
        label: i18n.t(LOCALS.batch_convert_to_multi_stock),
      });
    }

    if (isAdmin && selectedRows.length > 0) {
      options.push({
        value: BATCH_OPTION_TYPE.BATCH_SYNC_ES,
        label: i18n.t(LOCALS.batch_sync_es),
      });
    }

    return options;
  }, [isProductForSaleToSold, selectedRows, isAdmin]);

  const [batchForSaleConfirmModelOpen, toggleBatchForSaleConfirmModelOpen] =
    useToggle(false);
  const [batchConvertToMultiStockOpen, toggleBatchConvertToMultiStockOpen] =
    useToggle(false);
  const [batchOptionType, setBatchOptionType] = useState(undefined);

  const onClickBatchOption = useCallback(async () => {
    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_PRINT) {
      handleForwardPrint(selectedRows);
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_PRINT_LABEL) {
      handleForwardPrintLabel(selectedRows);
      return;
    }

    const productIdList = selectedRows.map((i) => i.id);

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_STOCK) {
      const remark = window.prompt('備考欄');

      await updateStockStatus({
        productIdList,
        newStockStatus: PMS_PRODUCT_STOCK_STATUS.STOCKED,
        note: `后台批量操作商品入库: ${remark}`,
      });
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_FOR_SALE) {
      toggleBatchForSaleConfirmModelOpen(true);
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_PUBLISH) {
      await publishProduct(productIdList);
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_UN_PUBLISH) {
      await unPublishProduct(productIdList);
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_SOLD_OUT) {
      await updateStockStatus({
        productIdList,
        newStockStatus: PMS_PRODUCT_STOCK_STATUS.SOLD,
        note: '后台批量操作商品卖出',
      });
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_LENT_OUT) {
      const remark = window.prompt('備考欄');
      if (remark === null) return;

      await updateStockStatus({
        productIdList,
        newStockStatus: PMS_PRODUCT_STOCK_STATUS.LENT_OUT,
        note: `一括貸出: ${remark}`,
      });
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_BIND_ORDER) {
      Modal.confirm({
        title: '批量绑定订单',
        content: `将为选中的 ${selectedRows.length} 件已售出商品自动绑定订单，是否继续？`,
        okText: i18n.t(LOCALS.confirm),
        cancelText: i18n.t(LOCALS.cancel),
        onOk: async () => {
          const res = await soldProductBindOrder(productIdList);
          const failResults = res.results.filter((item) => !item.success);

          if (res.failCount === 0) {
            message.success(`成功绑定 ${res.successCount} 件商品`);
          } else {
            Modal.warning({
              title: '批量绑定结果',
              content: (
                <div className="space-y-1">
                  <div>
                    成功 {res.successCount} 件，失败 {res.failCount} 件
                  </div>
                  {failResults.map((item) => {
                    const row = selectedRows.find(
                      (i) => i.id === item.productId,
                    );
                    return (
                      <div key={item.productId}>
                        商品 {item.productId}
                        {row?.productSn ? `（${row.productSn}）` : ''}：
                        {item.message}
                      </div>
                    );
                  })}
                </div>
              ),
            });
          }

          getDataSource();
          setSelectedRows([]);
        },
      });
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_CONVERT_TO_MULTI_STOCK) {
      toggleBatchConvertToMultiStockOpen(true);
      return;
    }

    if (batchOptionType === BATCH_OPTION_TYPE.BATCH_SYNC_ES) {
      await syncProductToEs(productIdList);
      message.success(i18n.t(LOCALS.batch_sync_es_success));
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  }, [
    batchOptionType,
    getDataSource,
    handleForwardPrint,
    handleForwardPrintLabel,
    selectedRows,
    toggleBatchForSaleConfirmModelOpen,
    toggleBatchConvertToMultiStockOpen,
  ]);

  const [priceMissMatchOpen, togglePriceMissMatchOpen] = useToggle(false);
  const [priceMissMatchRecord, setPriceMissMatchRecord] = useState<
    UnwrapPromise<ReturnType<typeof getProductPriceComparison>>['mismatches']
  >([]);
  useEffect(() => {
    getProductPriceComparison().then((res) => {
      setPriceMissMatchRecord(res.mismatches);
    });
  }, []);

  return (
    <div className="space-y-4">
      <Modal
        title="一括販売"
        open={batchForSaleConfirmModelOpen}
        onCancel={toggleBatchForSaleConfirmModelOpen}
        footer={null}
        destroyOnClose
      >
        <Form
          onFinish={async ({
            note,
            autoPublish,
          }: {
            note?: string;
            autoPublish: boolean;
          }) => {
            await updateStockStatus({
              productIdList: selectedRows.map((i) => i.id),
              newStockStatus: PMS_PRODUCT_STOCK_STATUS.FOR_SALE,
              note: `后台批量操作商品售卖: ${
                note || ''
              }\n自动掲載: ${autoPublish}`,
              autoPublish,
            });
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }}
        >
          <Form.Item label="備考欄" name="note">
            <Input.TextArea rows={5} placeholder="備考欄"></Input.TextArea>
          </Form.Item>
          <Form.Item
            label="自動掲載"
            name="autoPublish"
            valuePropName="checked"
            initialValue={false}
          >
            <Switch></Switch>
          </Form.Item>

          <Form.Item className="mb-0">
            <Button.Group className="flex gap-2 justify-end">
              <Button onClick={toggleBatchForSaleConfirmModelOpen}>
                キャンセル
              </Button>
              <Button type="primary" htmlType="submit">
                OK
              </Button>
            </Button.Group>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title={i18n.t(LOCALS.batch_convert_to_multi_stock)}
        open={batchConvertToMultiStockOpen}
        onCancel={toggleBatchConvertToMultiStockOpen}
        footer={null}
        destroyOnClose
      >
        <Form
          initialValues={{ stock: 1 }}
          onFinish={async ({ stock }: { stock: number }) => {
            const res = await batchConvertToMultiStock({
              productIdList: selectedRows.map((i) => i.id),
              stock,
            });
            const failResults = res.results.filter((item) => !item.success);

            toggleBatchConvertToMultiStockOpen(false);

            if (res.failCount === 0) {
              message.success(
                i18n.t(LOCALS.batch_convert_to_multi_stock_success, {
                  count: res.successCount,
                }),
              );
            } else {
              Modal.warning({
                title: i18n.t(LOCALS.batch_convert_to_multi_stock_result),
                content: (
                  <div className="space-y-1">
                    <div>
                      {i18n.t(LOCALS.batch_convert_to_multi_stock_partial, {
                        success: res.successCount,
                        fail: res.failCount,
                      })}
                    </div>
                    {failResults.map((item) => {
                      const row = selectedRows.find(
                        (i) => i.id === item.productId,
                      );
                      return (
                        <div key={item.productId}>
                          {item.productId}
                          {row?.productSn ? `（${row.productSn}）` : ''}
                          {item.message ? `：${item.message}` : ''}
                        </div>
                      );
                    })}
                  </div>
                ),
              });
            }

            getDataSource();
            setSelectedRows([]);
            setBatchOptionType(undefined);
          }}
        >
          <p className="mb-4">
            {i18n.t(LOCALS.batch_convert_to_multi_stock_confirm, {
              count: selectedRows.length,
            })}
          </p>
          <Form.Item
            label={i18n.t(LOCALS.OSoMXAfuDT)}
            name="stock"
            rules={[{ required: true }, { type: 'integer', min: 1 }]}
          >
            <InputNumber min={1} precision={0} step={1} className="w-full" />
          </Form.Item>
          <Form.Item className="mb-0">
            <Button.Group className="flex gap-2 justify-end">
              <Button onClick={toggleBatchConvertToMultiStockOpen}>
                {i18n.t(LOCALS.cancel)}
              </Button>
              <Button type="primary" htmlType="submit">
                {i18n.t(LOCALS.confirm)}
              </Button>
            </Button.Group>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        onCancel={() => {
          setUpdateStockStatus(undefined);
        }}
        onOk={async () => {
          if (updateStockStatusData) {
            if (
              updateStockStatusData.newStockStatus ===
                PMS_PRODUCT_STOCK_STATUS.LENT_OUT &&
              !updateStockStatusData.note?.trim()
            ) {
              message.warning(i18n.t(LOCALS.please_enter_remark));
              return;
            }

            const { selectedLentOutPresetKey, ...updateStockStatusPayload } =
              updateStockStatusData;

            await updateStockStatus({
              ...updateStockStatusPayload,
              note: updateStockStatusData.note
                ? normalizeNoteToEn(updateStockStatusData.note)
                : undefined,
            });

            if (
              selectedLentOutPresetKey === LOCALS.lent_out_preset_maintenance
            ) {
              await updateProductsWithMaintenanceRemark({
                productIdList: updateStockStatusData.productIdList,
                getProductUpdateInfo: getProductUpdateInfoNew,
                updateProductRemark,
                date: dayjs().format('YYYY-MM-DD'),
                label: i18n.t(LOCALS.lent_out_preset_maintenance, {
                  lng: 'en',
                }) as string,
              });
            }

            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        }}
        title={i18n.t(LOCALS.stock_status_change_note) || ''}
        open={!!updateStockStatusData}
        footer={(originNode) => (
          <div className="flex items-center justify-between">
            {updateStockStatusData?.newStockStatus ===
            PMS_PRODUCT_STOCK_STATUS.LENT_OUT ? (
              <div className="flex gap-2">
                {[
                  LOCALS.lent_out_preset_maintenance,
                  LOCALS.lent_out_preset_photography,
                  LOCALS.lent_out_preset_display,
                ].map((key) => (
                  <Button
                    key={key}
                    size="small"
                    onClick={() => {
                      if (!updateStockStatusData) return;
                      setUpdateStockStatus({
                        ...updateStockStatusData,
                        note: i18n.t(key) as string,
                        selectedLentOutPresetKey: key,
                      });
                    }}
                  >
                    {i18n.t(key)}
                  </Button>
                ))}
              </div>
            ) : (
              <span />
            )}
            <div>{originNode}</div>
          </div>
        )}
      >
        <Input.TextArea
          rows={5}
          placeholder={i18n.t(LOCALS.remark) || ''}
          value={updateStockStatusData?.note}
          onChange={(e) => {
            if (!updateStockStatusData) return;
            setUpdateStockStatus({
              ...updateStockStatusData,
              note: e.target.value,
            });
          }}
        ></Input.TextArea>
      </Modal>

      <Card bodyStyle={{ padding: '16px' }}>
        <Form layout="inline">
          <Form.Item label={<Trans i18nKey={LOCALS.product_category}></Trans>}>
            <Cascader
              value={productCategoryIds || undefined}
              onChange={(value) => {
                if (!value) {
                  setProductCategoryIds(null);
                } else {
                  setProductCategoryIds(value.map((i) => Number(i)));
                }
                setPageNum(1);
              }}
              changeOnSelect
              placeholder={i18n.t(LOCALS.please_select) || ''}
              style={{ minWidth: 160 }}
              options={productCategoryCascaderOptions}
              showSearch={{
                filter: getCascaderFilter,
              }}
            />
          </Form.Item>

          <Form.Item label={<Trans i18nKey={LOCALS.keyword}></Trans>}>
            <Input.TextArea
              value={localKeyword}
              onChange={(e) => {
                setLocalKeyword(e.target.value);
              }}
              style={{ minWidth: 250 }}
              placeholder={i18n.t(LOCALS.please_enter) || ''}
            />
          </Form.Item>

          <Form.Item label={<Trans i18nKey={LOCALS.publish_status}></Trans>}>
            <Select
              allowClear
              value={publishStatus}
              onChange={(e) => {
                if (e === undefined) {
                  setPublishStatus(null);
                } else {
                  setPublishStatus(e);
                }
                setPageNum(1);
              }}
              style={{ minWidth: 200 }}
              placeholder={i18n.t(LOCALS.please_select) || ''}
            >
              {PUBLISH_STATUS_OPTION_LIST.map((d) => (
                <Select.Option key={d.value} value={d.value}>
                  {d.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label={<Trans i18nKey={LOCALS.stock_place} />}>
            <Select
              mode="multiple"
              allowClear
              value={stockPlaces?.length ? stockPlaces : undefined}
              onChange={(values) => {
                if (!values?.length) {
                  setStockPlaces(null);
                } else {
                  setStockPlaces(values);
                }
                setPageNum(1);
              }}
              style={{ minWidth: 200 }}
              placeholder={i18n.t(LOCALS.please_select) || ''}
            >
              {STOCK_PLACE_OPTION_LIST.map((d) => (
                <Select.Option key={d.value} value={d.value}>
                  {d.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label={i18n.t(LOCALS.rank)}>
            <Select
              value={rankList || undefined}
              onChange={(value) => {
                if (!value.length) {
                  setRankList(null);
                } else {
                  setRankList(value);
                }
                setPageNum(1);
              }}
              mode="multiple"
              allowClear
              style={{ width: 200 }}
              placeholder={i18n.t(LOCALS.please_select) || ''}
            >
              {rankSelectOptions.map((i) => (
                <Select.Option key={i.value} value={i.value}>
                  {i.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label={i18n.t(LOCALS.brand)}>
            <Select
              value={brandNameList || undefined}
              onChange={(value) => {
                if (!value.length) {
                  setBrandNameList(null);
                } else {
                  setBrandNameList(value);
                }
                setPageNum(1);
              }}
              mode="multiple"
              allowClear
              style={{ width: 200 }}
              placeholder={i18n.t(LOCALS.please_select) || ''}
            >
              {brandNameSelectOptions.map((i) => (
                <Select.Option key={i.value} value={i.value}>
                  {i.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label={i18n.t(LOCALS.product_pictures)}>
            <Select
              value={isHavePic}
              onChange={(value) => {
                if (value === undefined) {
                  setIsHavePic(null);
                } else {
                  setIsHavePic(value);
                }
                setPageNum(1);
              }}
              allowClear
              style={{ width: 200 }}
              placeholder={i18n.t(LOCALS.please_select) || ''}
            >
              <Select.Option value={true}>
                {i18n.t(LOCALS.available)}
              </Select.Option>
              <Select.Option value={false}>
                {i18n.t(LOCALS.unavailable)}
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label={i18n.t(LOCALS.product_source)}>
            <Select
              value={sourceTypeList || undefined}
              onChange={(value) => {
                if (!value.length) {
                  setSourceTypeList(null);
                } else {
                  setSourceTypeList(value);
                }
                setPageNum(1);
              }}
              mode="multiple"
              allowClear
              style={{ width: 200 }}
              placeholder={i18n.t(LOCALS.please_select) || ''}
            >
              {PRODUCT_SOURCE_TYPE_OPTION_LIST.map((i) => (
                <Select.Option key={i.value} value={i.value}>
                  {i.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label={i18n.t(LOCALS.WgIPBPPxEU)}>
            <Select
              allowClear
              value={skuType}
              onChange={(value) => {
                if (value === undefined) {
                  setSkuType(null);
                } else {
                  setSkuType(value);
                }
                setPageNum(1);
              }}
              style={{ width: 200 }}
              placeholder={i18n.t(LOCALS.please_select) || ''}
            >
              {PRODUCT_STOCK_TYPE_OPTION_LIST.map(({ value, labelKey }) => (
                <Select.Option key={value} value={value}>
                  {i18n.t(labelKey)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label={<Trans i18nKey={LOCALS.created_time} />}>
            <RangePicker
              className={classNames('w-full', {
                isMobile: 'w-[220px]',
              })}
              value={
                createTime.length === 2
                  ? [dayjs(createTime[0]), dayjs(createTime[1])]
                  : null
              }
              onChange={(dates) => {
                if (dates) {
                  setCreateTime([
                    dayjs(dates[0]).startOf('days').format() || '',
                    dayjs(dates[1]).endOf('days').format() || '',
                  ]);
                } else {
                  setCreateTime(null);
                }

                setPageNum(1);
              }}
            />
          </Form.Item>

          <Form.Item label={<Trans i18nKey={LOCALS.juusvCbRWo}></Trans>}>
            <RangePicker
              className={classNames('w-full', {
                isMobile: 'w-[220px]',
              })}
              value={
                entryTime.length === 2
                  ? [dayjs(entryTime[0]), dayjs(entryTime[1])]
                  : null
              }
              onChange={(dates) => {
                if (dates) {
                  setEntryTime([
                    dayjs(dates[0]).startOf('days').format() || '',
                    dayjs(dates[1]).endOf('days').format() || '',
                  ]);
                } else {
                  setEntryTime(null);
                }

                setPageNum(1);
              }}
            />
          </Form.Item>

          <Form.Item label={<Trans i18nKey={LOCALS.UNXRchiSDw}></Trans>}>
            <RangePicker
              className={classNames('w-full', {
                isMobile: 'w-[220px]',
              })}
              value={
                soldTime.length === 2
                  ? [dayjs(soldTime[0]), dayjs(soldTime[1])]
                  : null
              }
              onChange={(dates) => {
                if (dates) {
                  setSoldTime([
                    dayjs(dates[0]).startOf('days').format() || '',
                    dayjs(dates[1]).endOf('days').format() || '',
                  ]);
                } else {
                  setSoldTime(null);
                }

                setPageNum(1);
              }}
            />
          </Form.Item>

          <Form.Item label={<Trans i18nKey={LOCALS.on_sale} />}>
            <Switch
              checked={isFilterPromotion}
              onChange={(value) => {
                setIsFilterPromotion(value);
                setPageNum(1);
              }}
            />
          </Form.Item>

          {isAdmin && (
            <Form.Item label="是否有订单ID">
              <Radio.Group
                buttonStyle="solid"
                optionType="button"
                value={haveOrderId}
                onChange={(value) => {
                  setHaveOrderId(value.target.value);
                  setPageNum(1);
                }}
              >
                <Radio value={null}>全部</Radio>
                <Radio value={true}>是</Radio>
                <Radio value={false}>否</Radio>
              </Radio.Group>
            </Form.Item>
          )}

          <Form.Item>
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  setKeyword(localKeyword);
                  setPageNum(1);
                }}
              >
                <Trans i18nKey={LOCALS.search} />
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  setProductCategoryIds(null);
                  setKeyword('');
                  setLocalKeyword(''); // 同时重置本地状态
                  setSourceTypeList(null);
                  setBrandNameList(null);
                  setIsHavePic(null);
                  setRankList(null);
                  setStockPlaces(null);
                  setPublishStatus(null);
                  setSkuType(null);
                  setIsFilterPromotion(false);
                  setCreateTime(null);
                  setSoldTime(null);
                  setEntryTime(null);
                  setStockStatuses([]);
                  setPageNum(1);
                  setPageSize(10);
                }}
              >
                <Trans i18nKey={LOCALS.reset} />
              </Button>
              {canAddProduct && (
                <Button
                  type="primary"
                  onClick={() => {
                    window.location.href = '/pms/product-add';
                  }}
                  className="flex items-center gap-2"
                >
                  <Plus className="w-5 h-5" />
                  <Trans i18nKey={LOCALS.add} />
                </Button>
              )}
            </Space>
          </Form.Item>

          <Form.Item>
            <div className="items-center justify-center flex w-64">
              <Select
                value={batchOptionType}
                onChange={(e) => {
                  setBatchOptionType(e);
                }}
                disabled={selectedRows.length === 0}
                placeholder={i18n.t(LOCALS.StzCTlyrrP)}
                options={batchOptionList}
              ></Select>
              <Button
                onClick={onClickBatchOption}
                type="primary"
                disabled={selectedRows.length === 0 || !batchOptionType}
              >
                {i18n.t(LOCALS.confirm)}
              </Button>
            </div>
          </Form.Item>

          <Form.Item>
            {/* 先设定为选择的筛选条件下，超过 3000 个商品不给导出吧 */}
            <Button
              disabled={total > 3000}
              onClick={async () => {
                const { list } = await searchProductList(1, 3000);

                const headers = [
                  '商品ID',
                  '旧商品番号',
                  i18n.t(LOCALS.product_pictures),
                  i18n.t(LOCALS.brand),
                  '商品名',
                  '类别',
                  i18n.t(LOCALS.rank),
                  i18n.t(LOCALS.color),
                  i18n.t(LOCALS.material),
                  i18n.t(LOCALS.hardware),
                  i18n.t(LOCALS.stamp),
                  i18n.t(LOCALS.uMihwkqqts),
                  i18n.t(LOCALS.publish_status),
                  i18n.t(LOCALS.product_source),
                  i18n.t(LOCALS.currency),
                  i18n.t(LOCALS.selling_price),
                  '税抜き価格',
                  i18n.t(LOCALS.purchase_price),
                  '仕入価格（税抜）',
                  i18n.t(LOCALS.stock),
                  i18n.t(LOCALS.stock_place),
                  i18n.t(LOCALS.dwawuQNUEi),
                  i18n.t(LOCALS.UNXRchiSDw),
                  i18n.t(LOCALS.juusvCbRWo),
                ];

                const mappedData = list.map(
                  ({
                    id,
                    name,
                    price,
                    stock,
                    currency,
                    stockStatus,
                    costPrice,
                    description,
                    stockPlace,
                    publishStatus,
                    sourceType,
                    rank,
                    colorText,
                    materialText,
                    hardwareText,
                    stampText,
                    pic,
                    orderId,
                    soldTime,
                    brandName,
                    productCategoryId,
                    entryTime,
                  }) => {
                    const stockStatusLabelKey =
                      PMS_PRODUCT_STOCK_STATUS_OPTION_LIST.find(
                        (i) => i.value === stockStatus,
                      )?.labelKey || '';
                    const sourceTypeLabel =
                      PRODUCT_SOURCE_TYPE_OPTION_LIST.find(
                        (i) => i.value === sourceType,
                      )?.label;
                    // 获取商品类别名称
                    const categoryTarget = findCascaderOptionById(
                      productCategoryId,
                      productCategoryCascaderOptions,
                    );
                    // 获取第一级类别
                    let firstLevelCategory = '-';
                    if (categoryTarget?.treeIds) {
                      const categoryIds = categoryTarget.treeIds
                        .split(',')
                        .map(Number);
                      if (categoryIds.length > 0) {
                        // 找到第一级类别ID
                        const firstLevelCategoryId = categoryIds[0];
                        // 在顶层选项中查找对应的类别
                        const firstLevelOption =
                          productCategoryCascaderOptions.find(
                            (option) => option.value === firstLevelCategoryId,
                          );
                        if (firstLevelOption) {
                          firstLevelCategory = firstLevelOption.label;
                        }
                      }
                    }

                    return {
                      商品ID: id,
                      旧商品番号: description,
                      [i18n.t(LOCALS.product_pictures)]: pic || '',
                      [i18n.t(LOCALS.brand)]: brandName || '-',
                      商品名: name,
                      类别: firstLevelCategory,
                      [i18n.t(LOCALS.rank)]: rankSelectOptions.find(
                        (i) => i.value === rank,
                      )?.label,
                      [i18n.t(LOCALS.color)]: colorText,
                      [i18n.t(LOCALS.material)]: materialText,
                      [i18n.t(LOCALS.hardware)]: hardwareText,
                      [i18n.t(LOCALS.stamp)]: stampText,
                      [i18n.t(LOCALS.uMihwkqqts)]: stockStatusLabelKey
                        ? i18n.t(stockStatusLabelKey)
                        : stockStatus,
                      [i18n.t(LOCALS.publish_status)]: publishStatus
                        ? i18n.t(LOCALS.on_shelf)
                        : i18n.t(LOCALS.off_shelf),
                      [i18n.t(LOCALS.product_source)]: sourceTypeLabel
                        ? sourceTypeLabel
                        : '-',
                      [i18n.t(LOCALS.currency)]: currency,
                      [i18n.t(LOCALS.selling_price)]: price,
                      [i18n.t(LOCALS.czbRYWhFdZ)]:
                        currency === 'JPY'
                          ? Math.ceil(price / (1 + CONSUMPTION_TAX_RATE))
                          : price,
                      [i18n.t(LOCALS.stock)]: stock,
                      [i18n.t(LOCALS.purchase_price)]: costPrice,
                      '仕入価格（税抜）': costPrice
                        ? currency === 'JPY'
                          ? Math.ceil(
                              Number(costPrice) / (1 + CONSUMPTION_TAX_RATE),
                            )
                          : costPrice
                        : '-',
                      [i18n.t(LOCALS.stock_place)]: stockPlace,
                      [i18n.t(LOCALS.dwawuQNUEi)]: orderId,
                      [i18n.t(LOCALS.UNXRchiSDw)]: soldTime
                        ? dayjs(soldTime).format('YYYY-MM-DD')
                        : '-',
                      [i18n.t(LOCALS.juusvCbRWo)]: entryTime
                        ? dayjs(entryTime).format('YYYY-MM-DD')
                        : '-',
                    };
                  },
                );

                // 将数据转换为 Excel 格式
                const worksheet = XLSX.utils.json_to_sheet(mappedData, {
                  header: headers,
                });

                // 创建工作簿
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                  workbook,
                  worksheet,
                  'product export',
                );

                // 生成 Excel 文件并触发下载
                XLSX.writeFile(
                  workbook,
                  `商品リスト-${dayjs().format('YYYY-MM-DD')}.xlsx`,
                );
              }}
            >
              {i18n.t('download_excel')}（{total}）
            </Button>
          </Form.Item>

          {isAdmin && (
            <Form.Item>
              <Button
                type="default"
                danger={!!priceMissMatchRecord.length}
                onClick={togglePriceMissMatchOpen}
              >
                {i18n.t(LOCALS.bOYktSqeQU)}（{priceMissMatchRecord.length}）
              </Button>
            </Form.Item>
          )}
        </Form>
      </Card>

      <Card bodyStyle={{ padding: '16px' }}>
        <div className="grid grid-cols-2 lg:grid-cols-7 gap-4 mb-4">
          {PMS_PRODUCT_STOCK_STATUS_OPTION_LIST.filter((i) => {
            return [
              PMS_PRODUCT_STOCK_STATUS.PENDING_ENTRY,
              PMS_PRODUCT_STOCK_STATUS.STOCKED,
              PMS_PRODUCT_STOCK_STATUS.FOR_SALE,
              PMS_PRODUCT_STOCK_STATUS.LENT_OUT,
              PMS_PRODUCT_STOCK_STATUS.RESERVED,
              PMS_PRODUCT_STOCK_STATUS.SOLD,
              PMS_PRODUCT_STOCK_STATUS.RENTAL_STOCK,
            ].includes(i.value);
          }).map(({ value, label }) => {
            const isChecked = stockStatuses?.includes(value);
            const isRentalStock =
              value === PMS_PRODUCT_STOCK_STATUS.RENTAL_STOCK;

            return (
              <div
                key={value}
                className={classNames(
                  'text-center py-2 cursor-pointer rounded',
                  isChecked
                    ? isRentalStock
                      ? 'bg-black text-red-500'
                      : 'bg-black text-white'
                    : isRentalStock
                      ? 'bg-gray-200 text-red-500'
                      : 'bg-gray-200',
                )}
                onClick={() => {
                  if (isChecked) {
                    setStockStatuses(
                      stockStatuses?.filter((i: string) => i !== value) || [],
                    );
                  } else {
                    setStockStatuses([...(stockStatuses || []), value]);
                  }
                }}
              >
                {label}（
                {productStockStatusStatistics.find(
                  (i) => i.stockStatus === value,
                )?.count || 0}
                ）
              </div>
            );
          })}
        </div>

        <Table
          loading={loading}
          bordered
          tableLayout="auto"
          scroll={{ x: 'max-content' }}
          rowSelection={{
            selectedRowKeys: selectedRows.map((d) => d.id) as React.Key[],
            onChange: (_, selectedRows) => setSelectedRows(selectedRows),
          }}
          pagination={{
            total,
            pageSize,
            pageSizeOptions: ['10', '20', '24', '50', '100'],
            current: pageNum,
            showTotal: (total) =>
              `${i18n.t('total')} ${total} ${i18n.t('item')}`,
            onChange: (page, pageSize) => {
              setPageNum(page);
              setPageSize(pageSize);
            },
          }}
          rowKey={'id'}
          dataSource={dataSource}
          columns={columns}
        />
      </Card>

      <Modal
        title={i18n.t(LOCALS.rrooMUILfK)}
        closeIcon={false}
        width={'80%'}
        open={!!viewStockStatusProductId}
        footer={null}
        onCancel={() => {
          setViewStockStatusProductId(0);
        }}
      >
        <ProductStockStatusHistory productId={viewStockStatusProductId} />
      </Modal>

      <Modal
        title={i18n.t(LOCALS.bOYktSqeQU)}
        open={priceMissMatchOpen}
        onCancel={togglePriceMissMatchOpen}
        onOk={togglePriceMissMatchOpen}
        width={700}
      >
        <Table
          dataSource={priceMissMatchRecord}
          pagination={false}
          bordered
          rowKey={'productId'}
          columns={[
            {
              title: 'ID',
              dataIndex: 'productId',
              key: 'productId',
              render(productId: number) {
                return (
                  <a
                    href={`/pms/product-edit/${productId}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {productId}
                  </a>
                );
              },
            },
            {
              title: i18n.t(LOCALS.product_sn),
              dataIndex: 'productSn',
              key: 'productSn',
            },
            {
              title: i18n.t(LOCALS.FrlyfzfGME),
              dataIndex: 'dbPrice',
              key: 'dbPrice',
              render(price: number, { currency }: { currency: string }) {
                return `${currency} ${price.toLocaleString()}`;
              },
            },
            {
              title: i18n.t(LOCALS.AHBGzxjtrR),
              dataIndex: 'esPrice',
              key: 'esPrice',
              render(price: number, { currency }: { currency: string }) {
                return `${currency} ${price.toLocaleString()}`;
              },
            },
            {
              title: i18n.t(LOCALS.option),
              key: 'option',
              render({ productId }: { productId: number }) {
                return (
                  <Button
                    type="link"
                    onClick={async () => {
                      await syncProductToEs([productId]);
                      window.location.reload();
                    }}
                  >
                    一键同步
                  </Button>
                );
              },
            },
          ]}
        ></Table>
      </Modal>
    </div>
  );
};

export default ProductList;
